<template>
    <div class="join_relation_wrap"> 
        <el-dialog
        title="课程列表"
        :visible.sync="dialogValue"
        custom-class="join_relation_dialog"
        min-width="10%"
        @close="handleClose">
         <div slot="title" style="display: flex; align-items: center">
            <span>课程列表</span>
            <p class="common-title">提示：该列表只显示已上架且有章节的课程</p>
        </div>
        <div class="relation_table">
           <div class="relation_table_left">
                <el-scrollbar style="height:500px" class="maket_scrollbar">
                    <div class="relation_table_search">
                        <!-- <div class="relation_table_search_con">
                            <el-select v-model="searchObj.is_single" placeholder="请选择" @change="handleisSingle">
                                <el-option
                                v-for="item in tabsList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div> -->
                         <div class="relation_table_search_con">
                            <el-input placeholder="请输入课程标题查询" v-model="searchObj.product_name" class="relation_input_tit">
						        <el-button slot="append" type="primary"  @click="search">查询</el-button>
					        </el-input>
                        </div>
                    </div>
                    <el-table :data="tableList.list" @row-click="(row) => { rowClick(row, 'class')}" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" v-loading="isLoading === 'noFullScreen' && !loading"  element-loading-text="加载中" element-loading-spinner="el-icon-loading">
                        <div slot="empty" style="height:380px;transform:scale(2);transform-origin: 50% 0%;">
						    <img :src="require(`@/assets/image/${classNoDataName}.png`)" style="width: 100%;padding: 25px 0;"/>
					    </div>
                        <el-table-column label="" width="50">
                            <template slot-scope="scope">
                                <input type="radio" :checked="scope.row.id == selectClassObj.id"/>
                            </template>
                        </el-table-column>product_type
                        <el-table-column property="img" label="封面" width="150">
                            <template slot-scope="scope">
                                <img :src="scope.row.img" alt="" style="width:67px;height:50px"/>
                            </template>
                        </el-table-column>
                        <el-table-column property="title" label="标题" width="300"></el-table-column>
                    </el-table>
                    <Pagination @change="changeSize" :total="tableList.count" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(tableList.count / searchObj.limit) > 1" class="relation_pagination"></Pagination>
                </el-scrollbar>
           </div>
           <!-- searchObj.is_single == -1 && ischapterShow -->
           <div class="relation_table_right" v-if="ischapterShow">
                <el-scrollbar style="height:500px" class="maket_scrollbar">
                    <div class="relation_table_search">
                        <div class="relation_table_search_con">
                            <el-input placeholder="请输入内容" v-model="searchObj1.show_name" class="relation_input_tit">
						        <div slot="append">
                                    <el-button type="primary" @click="search1">查询</el-button>
                                </div>
					        </el-input>
                        </div>
                    </div>
                    <el-table :data="tableList1.list" @row-click="(row) => { rowClick(row, 'chapter')}" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" v-loading="isLoading === 'noFullScreen' && loading"  element-loading-text="加载中" element-loading-spinner="el-icon-loading">
                        <div slot="empty" style="height:380px;transform-origin: 50% 0%;" :style="{'transform': `scale(${chapterNoDataName == 'empty'? 3: 2.5})`}">
						    <img :src="require(`@/assets/image/${chapterNoDataName}.png`)" style="width: 100%;padding: 25px 0;"/>
					    </div>
                        <el-table-column label="" width="50">
                            <template slot-scope="scope">
                                <input type="radio" :checked="scope.row.id == selectChapterObj.id"/>
                            </template>
                        </el-table-column>
                        <el-table-column property="title" label="标题" width="280" align="center"></el-table-column>
                    </el-table>
                    <Pagination @change="changeSize1" :total="tableList1.count" ref="pagination" v-model="searchObj1.page" v-if="Math.ceil(tableList1.count / searchObj1.limit) > 1" class="relation_pagination"></Pagination>
                </el-scrollbar>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions,mapState } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
export default {
    props: {
        dialogValue: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'dialogValue',
        event: 'change'
    },
    components: {
        Pagination
    },
    data() {
        return {
            dialogVisible: false,
            tableList: {
                list: [],
                count: 0
            },
            selectClassObj: {},
            selectChapterObj: {},
            tabsList: [
                {
                    label: '单课',
                    value: 1
                },
                {
                    label: '课程',
                    value: -1
                }
            ],
            searchObj: {
                is_single: 1,
                limit: 10,
                page: 1,
                product_name: ''
            },
            searchObj1: {
                limit: 10,
                page: 1,
                show_name: '',
                product_id: ''
            },
            tableList1: {
                list: [],
                count: 0
            },
            classNoDataName: 'empty',
            chapterNoDataName: 'empty',
            ischapterShow: false,
            loading: false
        }
    },
    created() {
        // this.getProductSelect()
    },
    computed: {
        ...mapState(['isLoading'])
    },
    methods: {
        ...mapActions('relation', ['authorCourseIndex', 'authorShowIndex']),
        rowClick(row, type) {
            if(type == 'class') {
                this.selectClassObj = row
            } else {
                this.selectChapterObj = row
            }
            if(this.searchObj.is_single == 1 && type == 'class') {
                this.selectChapterObj = {}
                this.ischapterShow = false
            }
            if(type == 'class') {
                this.loading = true
                this.ischapterShow = true
                this.searchObj1.product_id = row.id
                this.chapterNoDataName = 'empty'
                this.searchObj1.page = 1
                this.searchObj1.show_name = ''
                this.selectChapterObj = {}
                this.getAuthorShowIndex()
            } 
            console.log(row, 'pp')
        },
        handleClose() {
            this.$emit('change', false)
        },
        sure() {
            this.$emit('change', false)
            this.$emit('sure', this.selectClassObj, this.selectChapterObj)
        },
        handleisSingle(value) {
            this.loading = false
            this.searchObj.is_single = value
            this.classNoDataName = 'empty'
            this.searchObj.page = 1
            this.searchObj.product_name = ''
            this.getProductSelect()
            this.$forceUpdate()
        },
        changeSize(size) {
            this.searchObj.page = size
            this.getProductSelect()
        },
        changeSize1(size) {
            this.searchObj1.page = size
            this.getAuthorShowIndex()
        },
        async getProductSelect() {
            let res = await this.authorCourseIndex(this.searchObj)
            this.tableList = {
                list: res.data,
                count: res.count
            }
        },
        async getAuthorShowIndex() {
            let res = await this.authorShowIndex(this.searchObj1)
            this.tableList1 = {
                list: res.data,
                count: res.count
            }
            this.loading = false
        },
        search() {
            this.classNoDataName = 'noData'
            this.searchObj.page = 1
            this.getProductSelect()
        },
        search1() {
            this.chapterNoDataName = 'noData'
            this.searchObj1.page = 1
            this.getAuthorShowIndex()
        }
    },
    watch: {
        dialogValue(news) {
            if(news) {
                this.getProductSelect()
            }
        }
    }
}
</script>
<style lang="less">
    .join_relation_dialog {
        display: inline-block;
        left: 50%;
        transform: translateX(-50%);
        width: auto;
        .el-dialog__header {
            padding-bottom: 0;
        }
        .el-dialog__body {
            padding-top: 0;
            padding-bottom: 12px;
        }
        .relation_input_tit {
            .el-input-group__append, .el-input-group__prepend {
                background-color: #409eff;
                border-color: #409eff;
                color: #fff;
            }
        }
    }
    .relation_table {
        display: flex;
        .relation_table_search {
            margin-bottom: 12px;
            display: flex;
            flex-wrap: wrap;
            .relation_table_search_con {
                margin-left: 12px;
                flex-shrink: 0;
            }
        }
        .relation_table_left {
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
            padding: 10px;
            box-sizing: border-box;
        }
        .relation_table_right {
            margin-left: 12px;
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
            padding: 10px;
            box-sizing: border-box;
        }
        .relation_pagination {
            padding: 12px 0 0 0;
            .el-pagination {
                display: flex;
            }
            .el-pager {
                display: flex;
                align-items: center;
            }
        }
    }
</style>